import React from 'react';

const useContainerClassname = (containerClass: string, width?: string) => {
  return React.useMemo(() => {
    const classNames = [`p-8 text-black w-${width ?? '96'}`];

    if (containerClass) {
      classNames.push(containerClass);

      if (containerClass.includes('bg')) {
        classNames.push('bg-gray-50');
      }
    }
    return classNames.join(' ');
  }, [containerClass, width]);
};

export default useContainerClassname;
